"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StatManager {
    constructor(ruleMap) {
        this.paramsMap = {};
        this.ruleMap = {};
        this.ruleMap = ruleMap || {};
    }
    setParam(key, obj) {
        this.paramsMap[key] = obj;
    }
    setParams(params) {
        this.paramsMap = Object.assign(this.paramsMap, params);
    }
    setRule(key, rule) {
        this.ruleMap[key] = rule;
    }
    setRules(rules) {
        this.ruleMap = Object.assign(this.ruleMap, rules);
    }
    toLogsByRule(rule, extraParams) {
        let logs = {};
        Object.keys(rule.params).forEach((key) => {
            const ruleItem = rule.params[key];
            if (typeof ruleItem === 'string') {
                if (ruleItem.indexOf('~') === 0) {
                    const ruleItemKey = ruleItem.substr(1);
                    logs[key] = this.paramsMap[ruleItemKey];
                }
                else {
                    logs[key] = ruleItem;
                }
            }
            else if (Array.isArray(ruleItem)) {
                if (key === '_extend') {
                    ruleItem.forEach((ruleItemKey) => {
                        if (ruleItemKey.indexOf('~') === 0) {
                            ruleItemKey = ruleItemKey.substr(1);
                            logs[ruleItemKey] = this.paramsMap[ruleItemKey];
                        }
                    });
                }
            }
        });
        if (extraParams) {
            logs = Object.assign({}, logs, extraParams);
        }
        return logs;
    }
    toLogs(ruleKey, extraParams) {
        const rule = this.ruleMap[ruleKey];
        return this.toLogsByRule(rule, extraParams);
    }
}
exports.default = StatManager;
//# sourceMappingURL=data:application/json;base64,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